export class Attribute {
  constructor(props = {}) {
    this.order = props.order
    this.tag = props.tag || ''
    this.value = props.value || ''
  }

  isEmpty = () => {
    return this.tag === '' || this.value === ''
  }
}

